import { render } from "./Classes.vue?vue&type=template&id=c97832ce&scoped=true"
import script from "./Classes.vue?vue&type=script&lang=js"
export * from "./Classes.vue?vue&type=script&lang=js"

import "./Classes.vue?vue&type=style&index=0&id=c97832ce&scoped=true&lang=css"
import "./Classes.vue?vue&type=style&index=1&id=c97832ce&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c97832ce"]])

export default __exports__